import React, { Component } from 'react';
import { message } from 'antd';

import { queryTerminationInfo } from '@api/incubator/termination';
import { queryBusinessInfo } from '@api/common/business';
import localDb from '@util/localDb';

import PageStationEdit from './station/PageEdit';
import PageStationOpen from './station/PageOpen';
import PageAddressEdit from './address/PageEdit';
import PageAddressOpen from './address/PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {
        business: {},
        payables: [],
      },
      payables: [],
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.terminationInfo();
  }

  terminationInfo = () => {
    queryTerminationInfo({
      uuid: this.props.params.terminationUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        if (res.data.payables) {
          this.businessInfo(res.data.business.uuid, res.data.payables);
        }
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  handleDataInfo = dataInfo => {
    this.setState({
      dataInfo,
    });
  };

  businessInfo = (businessUuid, payables) => {
    queryBusinessInfo({
      businessUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        (res.data.payables || []).forEach(item => {
          item.refund = 0;
        });
        res.data.payables.map(item => this.initPayablesEdit(item, payables));
        this.setState({
          payables: res.data.payables,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /** 太过复杂需要优化 */
  // 组合合同详情与终止详情，显示最终的终止详情相关账单
  initPayablesEdit = (payableItem, payables) => {
    payables.forEach(item => {
      if (item.liquidate && payableItem.type === 0) {
        this.liquidateUuid = item.liquidate.uuid;
        payableItem.damages = item.liquidate.price;
      }
      if (item.terms.length > 0) {
        if (item.no === payableItem.payableNo) {
          payableItem.refund = 0;
          payableItem.obsolete = 0;
          item.terms.forEach(item1 => {
            if (item1.payType === 1) {
              payableItem.obsoleteUuid = item1.uuid;
              payableItem.obsolete += item1.price;
            }
            if (item1.payType === 2 && item1.status === 0) {
              payableItem.refundUuid = item1.uuid;
              payableItem.refund += item1.price;
            }
          });
        }
      }
    });
  };

  render() {
    const { dataInfo, payables } = this.state;
    const contractType = dataInfo.business.type;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return contractType === 'settled' ? (
        <PageStationEdit data={dataInfo} {...this.props} />
      ) : (
        <PageAddressEdit data={dataInfo} {...this.props} />
      );
    }
    if (dataInfo.uuid) {
      return contractType === 'settled' ? (
        <PageStationOpen data={dataInfo} {...this.props} payables={payables} />
      ) : (
        <PageAddressOpen data={dataInfo} {...this.props} payables={payables} />
      );
    }
    return <span />;
  }
}

export default PageInfo;



// WEBPACK FOOTER //
// ./src/components/incubator/termination/PageInfo.js